import { z } from 'zod';
import { BARRIER_TYPES } from '@fortem-monorepo/constants';
export const barrierTypeSchema = z.enum(BARRIER_TYPES);
